import { render } from "./Test.vue?vue&type=template&id=24f39c44"
const script = {}
script.render = render

export default script